import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Input, Dialog, Message } from "@jdcfe/legao";
import {
  queryAppSecret,
  modifyAppInfo,
  queryAppRsaKey,
  linkContract,
} from "utils/api";
import BindContactInput from "./../BindContactInput";
// import useStores from 'stores';
import "./style.scss";
let md5 = require("md5");

export default observer(function AppInfo(props) {
  const { itemData } = props;
  const [submitLoading, setSubmitLoading] = useState(false);
  const [eyeopen, setEyeOpen] = useState(false);
  const [editName, setEditName] = useState(false);
  const [editUrl, setEditUrl] = useState(false);
  const [urlName, setUrlName] = useState(itemData.authCallbackUrl);
  const [urlChange, setUrlChange] = useState(itemData.authCallbackUrl);
  const [appName, setAppName] = useState(itemData.appName);
  const [appNamechange, setAppNamechange] = useState(itemData.appName);
  const [appsecret, setAppSecret] = useState("");
  const [secretLoading, setSecretLoading] = useState(false);

  // const { frameStore } = useStores();

  useEffect(() => {
    setAppName(itemData.appName);
    setAppNamechange(itemData.appName);
    setUrlName(itemData.authCallbackUrl);
    setUrlChange(itemData.authCallbackUrl);
  }, [itemData]);

  const handleSecret = () => {
    if (eyeopen) {
      return setEyeOpen(!eyeopen);
    }
    if (secretLoading) {
      Message.showMsg({
        showIcon: true,
        type: "warn",
        description: "请稍等再试",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return;
    }
    setSecretLoading(true);
    queryAppSecret({
      appKey: itemData.appKey,
    }).then((res) => {
      if (res.data.success) {
        setAppSecret(res.data.result.appSecret);
      }
      setSecretLoading(false);
    });
    return setEyeOpen(!eyeopen);
  };
  const handleEditUrl = () => {
    return setEditUrl(true);
  }
  const cancelSetUrl = () => {
    setUrlChange(editUrl);
    return setEditUrl(false);
  }
  const inputUrlChange = (e) => {
    setUrlChange(e.target.value);
  }
  const saveUrl = () => {
    //保存接口
    if (urlChange.trim() === "") {
      Message.showMsg({
        showIcon: true,
        type: "warn",
        description: "回调地址不能为空",
        autohide: true,
        closable: false,
        duration: 1000,
      });
      return;
    } else {
      modifyAppInfo({
        appKey: itemData.appKey,
        appName: null,
        authCallbackUrl: urlChange,
      }).then((res) => {
        if (res.data.success) {
          Message.showMsg({
            showIcon: true,
            type: "success",
            description: "修改成功，由于网络问题可能会导致显示延迟，请10秒后刷新网页查看",
            autohide: true,
            closable: false,
            duration: 4000,
          });
          setTimeout(() => {
            location.reload();
          }, 4000);
        } else {
          setTimeout(() => {
            setEditUrl(false);
          });
        }
      });
    }
  }
  const handleEdit = () => {
    return setEditName(true);
  };
  const cancelSetName = () => {
    setAppNamechange(appName);
    return setEditName(false);
  };
  const inputChange = (e) => {
    setAppNamechange(e.target.value);
  };
  const saveName = () => {
    if (appNamechange === "") {
      Message.showMsg({
        showIcon: true,
        type: "warn",
        description: "应用名称不能为空",
        autohide: true,
        closable: false,
        duration: 1000,
      });
      return;
    } else {
      modifyAppInfo({
        appKey: itemData.appKey,
        appName: appNamechange,
        authCallbackUrl: null,
      }).then((res) => {
        if (res.data.success) {
          Message.showMsg({
            showIcon: true,
            type: "success",
            description: "保存成功",
            autohide: true,
            closable: false,
            duration: 1000,
          });
          // frameStore.updateAppName(appNamechange);
          // setAppName(appNamechange);
          setTimeout(() => {
            location.reload();
          }, 1000);
        } else {
          setTimeout(() => {
            setEditName(false);
          });
        }
      });
      // setEditName(false);
    }
  };
  const handleDownload = () => {
    queryAppRsaKey({
      appKey: itemData.appKey,
    }).then((res) => {
      if (res.data.success && res.data.result) {
        const a = document.createElement("a");
        const blob = new Blob(
          [
            "私钥：" + res.data.result.rsaPrivateKey,
            "\r\n公钥：" + res.data.result.rsaPublicKey,
          ],
          { type: "text/plain" }
        );
        const url = URL.createObjectURL(blob);
        a.setAttribute("href", url);
        a.setAttribute("download", "密钥文件.txt");
        a.click();
      }
    });
  };
  const handleBind = () => {
    const binContact = Dialog.confirm({
      title: "绑定合同主数据",
      children: <BindContactInput appKey={itemData.appKey}></BindContactInput>,
      wrapStyle: {
        zIndex: 99,
      },
      actions: [
        {
          text: "提交",
          onClick: () => {
            sureClick(binContact);
          },
          className: "sure",
          styleType: "primary",
          autoClose: false,
        },
        {
          text: "取消",
          onClick: () => binContact.close(),
          className: "cancel",
          styleType: "",
        },
      ],
      className: "bind_dialog",
    });
  };
  const sureClick = (binContact) => {
    const clientId = document.querySelector(".contractNumber .lg-input-o")
      .value;
    const bizUserPin = document.querySelector(".bizUserPin .lg-input-o").value;
    const bizUserPwdMd5 = md5(
      document.querySelector(".bizUserPwdMd5 .lg-input-o").value
    );
    if (submitLoading) {
      Message.showMsg({
        showIcon: true,
        type: "warn",
        description: "请稍等再试",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return;
    }
    setSubmitLoading(true);
    linkContract({
      appKey: itemData.appKey,
      clientId,
      bizUserPin,
      bizUserPwdMd5,
    }).then((res) => {
      if (document.querySelector(".input_item.error"))
        document.querySelector(".input_item.error").classList.remove("error");
      if (!res.data.success) {
        if (res.data.resultCode === "30001001") {
          document
            .querySelector(".contractNumber")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".contractNumber").nextSibling.innerHTML =
            res.data.resultMessage;
        } else if (res.data.resultCode === "30001002") {
          document
            .querySelector(".bizUserPin")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".bizUserPin").nextSibling.innerHTML =
            res.data.resultMessage;
        } else if (res.data.resultCode === "30001003") {
          document
            .querySelector(".bizUserPwdMd5")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".bizUserPwdMd5").nextSibling.innerHTML =
            res.data.resultMessage;
        }else{
          Message.showMsg({
            showIcon: true,
            type: "wrong",
            description:res.data.resultMessage,
            autohide: true,
            closable: false,
            duration: 1000,
          });
        }
      } else {
        // if (document.querySelector(".input_item.error")) document.querySelector(".input_item.error").classList.remove("error");
        Message.showMsg({
          showIcon: true,
          type: "success",
          description: "绑定成功",
          autohide: true,
          closable: false,
          duration: 2000,
        });
        binContact.close();
        setTimeout(() => {
          location.reload();
        }, 2000);
      }
      setSubmitLoading(false);
    });
  };

  return (
    <div className="app_info">
      <div className="info_title">应用信息</div>
      <div className="info_content">
        <div className="content_item">
          <div className="item_detail">
            <span className="detail_title">应用 ID：</span>
            <span className="detail_content">{itemData.appId}</span>
          </div>
          <div className="item_detail">
            <span className="detail_title">AppKey：</span>
            <span className="detail_content">{itemData.appKey}</span>
          </div>
          <div className="item_detail">
            <span className="detail_title">密钥文件：</span>
            <span className="detail_content">
              <i className="qus"></i>
              <div className="que_tips">
                RSA公钥和私钥文件，用于获取TOKEN时为密码加密
                <div className="arrow"></div>
                <div className="holder"></div>
              </div>
              <span className="download" onClick={handleDownload} clstag="pageclick|keycount|VopOpenConsole_1611892618710|2">
                下载
              </span>
            </span>
          </div>
          <div className="item_detail item_detail_url_name">
            <span className="detail_title">回调地址：</span>
            <span className="detail_content">
            {editUrl ? (
                <span>
                  <Input
                    placeholder="请输入回调地址，英文逗号分隔"
                    defaultValue={urlName}
                    maxLength={256}
                    onChange={inputUrlChange}
                    hasClear
                    style={{bottom: '-8px', top: 'auto'}}
                  />
                  <span className="saveCancel">
                    <span className="save" onClick={saveUrl}>
                      保存
                    </span>
                    <span className="cancel" onClick={cancelSetUrl}>
                      取消
                    </span>
                  </span>
                </span>
              ) : (
                <>
                  <span className="urlname"> {urlName}</span>
                  <span className="edit" onClick={handleEditUrl}>
                    编辑
                  </span>
                </>
              )}
            </span>
          </div>
        </div>
        <div className="content_item">
          <div className="item_detail">
            <span className="detail_title">应用名称：</span>
            <span className="detail_content">
              {editName ? (
                <span>
                  <Input
                    placeholder="请输入应用名称"
                    defaultValue={appName}
                    maxLength={10}
                    onChange={inputChange}
                    hasClear
                  />
                  <span className="saveCancel">
                    <span className="save" onClick={saveName} clstag="pageclick|keycount|VopOpenConsole_1611892618710|10">
                      保存
                    </span>
                    <span className="cancel" onClick={cancelSetName} clstag="pageclick|keycount|VopOpenConsole_1611892618710|9">
                      取消
                    </span>
                  </span>
                </span>
              ) : (
                <span>
                  <span>{appName}</span>
                  <span className="edit" onClick={handleEdit} clstag="pageclick|keycount|VopOpenConsole_1611892618710|3">
                    编辑
                  </span>
                </span>
              )}
            </span>
          </div>
          <div className="item_detail">
            <span className="detail_title">AppSecret：</span>
            <span className={`detail_content ${eyeopen ? "checked" : ""}`}>
              {eyeopen ? appsecret : "********"}
              <i className="check" onClick={handleSecret} clstag="pageclick|keycount|VopOpenConsole_1611892618710|4"></i>
            </span>
          </div>
          <div className="item_detail">
            <span className="detail_title">ClientId：</span>
            {itemData.clientId ? (
              <span className="detail_content">{itemData.clientId}</span>
            ) : (
              <span className="detail_content todo" onClick={handleBind}>
                去绑定
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
